/**
 * store/modules/admin/adminPayout.js
 *
 * Vuex module handling admin payout state and actions.
 */
import axios from 'axios'

export default {
  // admin payout state.
  state: {
    adminPayoutPending: [],
    adminPayoutPaid: [],
    adminPayoutRequest: {}
  },

  // Mutations to alter admin payout state.
  mutations: {
    setPayoutPending: (state, statusList) => (state.adminPayoutPending = statusList),
    setPayoutPaid: (state, statusList) => (state.adminPayoutPaid = statusList),
    setPayoutRequest: (state, request) => (state.adminPayoutRequest = request)
  },

  // Actions handling requests, and committing mutations.
  actions: {
    /**
     * Grab the payout pending list.
     */
    async getPendingStatus ({ commit }) {
      try {
        let response = await axios.get('/api/admin/payout/Pending')
        // Payout list fetch success, set to state.
        commit('setPayoutPending', response.data)
      }
      catch {
        // Payout list fetch failed.
        console.error('Unable to fetch pending payouts.')
      }
    },

    /**
     * Grab the payout paid list.
     */
    async getPaidStatus ({ commit }) {
      try {
        let response = await axios.get('/api/admin/payout/Paid')
        // Payout list fetch success, set to state.
        commit('setPayoutPaid', response.data)
      }
      catch {
        // Payout list fetch failed.
        console.error('Unable to fetch completed payouts.')
      }
    },

    /**
     * Mark a payment request as paid.
     *
     * lookup: string (required)
     */
    async markAsPaid ({dispatch}, lookup) {
      try {
        await axios.post(`/api/admin/payout/${lookup}`)
        // Set as paid, refresh the list.
        dispatch('getPendingStatus')
      }
      catch {
        // Payout resolution failed.
        console.error('Unable to mark request as paid.')
      }
    }
  },

  // Payout state getters.
  getters: {
    adminPayoutPending: state => state.adminPayoutPending,
    adminPayoutPaid: state => state.adminPayoutPaid,
    adminPayoutRequest: state => state.adminPayoutRequest
  }
}
